export const getCatalogTitleList = (theTemp: any, theData: any) => {
    const result = [];
    for (let i = 0; i < theTemp.length; i++) {
        const itemA: any = theTemp[i];
        if (itemA.name === 'BlogTitle') {
            const itemB = theData[itemA.id];
            if (!itemB) {
                continue;
            }
            if (itemB.type === 'H1') {
                continue;
            }
            if (itemB.type === 'H2') {
                result.push({
                    title: itemB.title,
                    id: `#${itemA.id}`,
                });
            }
        }
    }
    return result;
};
